import { API_BASE_URL } from "./constants";

/**
 * URL to load a catalog image onto the Fabric canvas (and for thumbnails) without relying on S3 CORS.
 * Uses the API proxy when `image_path` is under `builder/`.
 */
export function getInvitationBuilderLibraryImageLoadUrl(item) {
  if (!item || typeof item !== "object") return null;
  const key = item.image_path;
  if (typeof key === "string" && key.startsWith("builder/")) {
    const base = (API_BASE_URL || "").replace(/\/$/, "");
    return `${base}/invitation-builder/library-image?key=${encodeURIComponent(key)}`;
  }
  if (typeof item.image_url === "string" && item.image_url.length) {
    return item.image_url;
  }
  return null;
}
